import { Grid, FormControl, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { memo } from 'react';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import ForeignState from './foreign-state';
import ItalianState from './italian-state';
import { FormikErrors, FormikTouched } from 'formik';

interface ItalianForeignStateProps {
  isForeign?: boolean;
  onChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
  foreignStateBirth?: ForeignStateVM | null;
  foreignMunicipality?: MunicipalityAnprVM | null;
  provinceOfBirth?: string;
  municipalityOfBirth?: MunicipalityAnprVM | null;
  locality?: string;
  onChangeValues: (values: AccordionGeneralityFormVM) => void;
  values?: AccordionGeneralityFormVM;
  errors?: FormikErrors<AccordionGeneralityFormVM>;
  touched?: FormikTouched<AccordionGeneralityFormVM>;
}

const ItalianForeignStateComponent = ({
  isForeign,
  onChange,
  foreignStateBirth,
  foreignMunicipality,
  provinceOfBirth,
  municipalityOfBirth,
  locality,
  onChangeValues,
  errors,
  touched,
}: ItalianForeignStateProps): React.ReactElement => {
  return (
    <Grid item container spacing={0} alignItems="center">
      <Grid item xs={12} md={3}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Stato"
            id="isForeign"
            value={isForeign || 'false'}
            onChange={() =>
              onChangeValues({
                isForeign: !isForeign,
                foreignStateBirth: null,
                foreignMunicipality: null,
                provinceOfBirth: '',
                municipalityOfBirth: null,
                locality: '',
              })
            }
          >
            <FormControlLabel
              // onClick={() => {
              //   resetItalian();
              // }}
              value="false"
              control={<Radio />}
              label="Italiano"
            />
            <FormControlLabel
              // onClick={() => {
              //   resetForeign();
              // }}
              value="true"
              control={<Radio />}
              label="Estero"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      {isForeign ? (
        <ForeignState
          onChange={onChange}
          foreignStateBirth={foreignStateBirth}
          foreignMunicipality={foreignMunicipality}
          errors={errors}
          touched={touched}
        />
      ) : (
        <ItalianState
          onChange={onChange}
          provinceOfBirth={provinceOfBirth}
          municipalityOfBirth={municipalityOfBirth}
          locality={locality}
          errors={errors}
          touched={touched}
        />
      )}
    </Grid>
  );
};

ItalianForeignStateComponent.displayName =
  'Filters Person section Italian or Foreign State component';

const ItalianForeignState = memo(ItalianForeignStateComponent);

export default ItalianForeignState as typeof ItalianForeignStateComponent;
